const styles = () => ({
    mainTabs: {
        borderBottom: '1px solid #ccc',
    },
    tabMainTab: {
        backgroundColor: '#ccc',
    },
    labelMainTab: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
    },
    containerForm: {
        minHeight: '300px',
        position: 'relative',
        paddingBottom: '60px',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    finalizeContainer: {
        position: 'absolute',
        right: '-1.13em',
        width: 'calc(100% + 4em)',
        bottom: '-1.2em',
        backgroundColor: '#e9e9e9',
        justifyContent: 'flex-end',
        padding: '20px',
    },
    finalizeBtn: {
        borderRadius: '25px',
        paddingRight: '20px',
        paddingLeft: '20px',
        height: '50px',
    },
    sendSurvey: {
        borderRadius: '25px',
        paddingRight: '20px',
        paddingLeft: '20px',
        height: '50px',
        marginLeft: '15px',
    },
    colorWhite: {
        color: '#fff',
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
